export default function PageIntro({ eyebrow, title, description, children }) {
  return (
    <section className="relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-12 sm:pt-24 sm:pb-16">
        <div className="grid lg:grid-cols-12 gap-8 items-end">
          <div className="lg:col-span-8 animate-fade-up">
            {eyebrow && <p className="eyebrow mb-6">{eyebrow}</p>}
            <h1 className="font-serif font-light text-5xl sm:text-6xl lg:text-7xl tracking-tight text-forest leading-[0.95] text-balance">
              {title}
            </h1>
          </div>
          {description && (
            <p className="lg:col-span-4 text-base sm:text-lg leading-relaxed text-charcoal/70 font-light lg:pb-2 animate-fade-up" style={{ animationDelay: "120ms" }}>
              {description}
            </p>
          )}
        </div>
        {children}
        <div className="hairline mt-12" />
      </div>
    </section>
  );
}
